


































































import Vue from 'vue'
import axios from 'axios'
import API from '@/utils/api'
import Component from 'vue-class-component'
import { i18n } from '@/plugins/i18n'
import { namespace } from 'vuex-class'
import { User } from '@/models/User'
import { Session } from '@/models/Session'
import { ProbableGameFromRg } from '@/models/ProbableGameFromRg'
import moment from '@/plugins/moment'
const AppStore = namespace('AppStore')
const SnackbarStore = namespace('SnackbarStore')

@Component({
  components: {},
})
export default class Home extends Vue {
  moment = moment
  @AppStore.Mutation setUser!: (user: User) => void
  @SnackbarStore.Mutation setSnackbarError!: (error: string) => void
  sessions: Session[] = []
  selectedGames: number[] = []
  probableGamesFromRg: ProbableGameFromRg[] = []
  currentPage: number = 1
  pageSize: number = 15
  showAll: boolean = false
  isHidden: boolean = false
  loading: boolean = false
  get pagesCount() {
    return Math.floor(this.visibleSessions.length / this.pageSize + 0.5)
  }
  get visibleSessions() {
    let res: any[] = this.sessions
    if (!this.showAll) {
      res = res.filter((x: any) => x.is_hidden === false)
    }
    return res
  }
  get filteredSessions() {
    return this.visibleSessions.slice(
      (this.currentPage - 1) * this.pageSize,
      this.currentPage * this.pageSize
    )
  }
  loadSessions() {
    return API.loadSessions().then((r) => {
      this.sessions = r.data
    })
  }
  loadProbablyGames() {
    return API.loadProbablyGames().then((r) => {
      this.probableGamesFromRg = r.data
      this.probableGamesFromRg.forEach((el, index) => {
        this.selectedGames.push(index)
      })
    })
  }
  createSession() {
    this.loading = true
    let rgGameIds: number[] = []
    let awGameIds: (number | null)[] = []
    this.selectedGames.forEach((el) => {
      let rgGame = this.probableGamesFromRg[el]
      let awGameId = rgGame.aw_game ? rgGame.aw_game.id : null
      rgGameIds.push(rgGame.id)
      awGameIds.push(awGameId)
    })
    return API.createSession(rgGameIds, awGameIds, this.isHidden)
      .then((r: any) => {
        this.$router.push({
          name: 'main',
          params: { sessionId: r.data.session_id },
        })
      })
      .catch((err: any) => {
        this.setSnackbarError(`Error creating session`)
      })
      .finally(() => {
        this.loading = false
      })
  }
  mounted() {
    this.loadSessions()
    this.loadProbablyGames()
  }
}
